// import {Editor} from '@tinymce/tinymce-react' // não usado
import {BaseSyntheticEvent, FC, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import uuid from 'react-uuid'
import Swal from 'sweetalert2'
import {Button} from '../../../../components/Button/Button'
import {Input} from '../../../../components/Input/Input'
import {Loading} from '../../../../components/Loading/Loading'
// import {DELETE, GET, POST, PUT} from '../../../../services/api' // DELETE não é usado
import {GET, POST, PUT} from '../../../../services/api'
import {i18n} from '../../../../translate/i18n'
// import useAuth from '../../../../hooks/useAuth' // não usado
// import useModals from '../../../../hooks/useModals' // não usado
// import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper' // não usado
// import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete' // não usado
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {set} from 'rsuite/esm/internals/utils/date'
// import {set} from 'rsuite/esm/internals/utils/date' // não usado

type AppconfigResponseType = {
  name: string
  locationId: number
  info: string
  color: string
  background: null | string
  banner: null | string
  imgLoundPage: null | string
  img: null | string
  icon: null | string
  fontFamily?: string
  content: {
    noShadow?: boolean
    qtdProductsPagination: number
    useLogoMenu: boolean
    colorLogo?: string
    useLogoTotvs?: boolean
    pdv: any
    orderCategory: string
    useCategoryList?: boolean
    imageBorderRadius?: string
    barBorderRadius?: string
    webappcolor?: {
      backgroundbuttonhome?: string
      backgroundcart?: string
      backgroundfooter?: string
      backgroundheader?: string
      backgroundmenu?: string
      backgroundstatus?: string
      backgroundstatusactive?: string
      backgroundtitlebar?: string
      backgroundwebapp?: string
      fontbutton?: string
      fontbuttonhome?: string
      fontcart?: string
      fontcategory?: string
      fontheader?: string
      fontinfocart?: string
      fontmenu?: string
      fontstatus?: string
      fonttitlebar?: string
      highlightfooter?: string
      iconsfooter?: string
      iconsheader?: string
      icontitlebar?: string
      colorIcons?: string
      iconButtonBackground?: string
      iconButtonBackgroundColor?: string
      webappbutton?: string
      iconHeaderFooterColor?: string
      priceCardBackground?: string
      priceCardFontColor?: string
    }
    fontFamily?: string
    restaurantList?: boolean
    restaurantDisplayMode?: boolean
    canAcessseRestaurant?: boolean
    iconButtonSize?: string
    shadowImage?: string
    skipLoudScreen?: boolean
    blackLogoNine?: boolean
  }
}

type AppconfigResponseSendType = {
  name?: string
  locationId?: number
  info?: string
  background?: null | string
  banner?: null | string
  img?: null | string
  imgLoundPage?: null | string
  icon?: null | string
  color?: string
  content?: {
    noShadow?: boolean
    qtdProductsPagination?: number
    useLogoMenu?: boolean
    colorLogo?: string
    useLogoTotvs?: boolean
    pdv?: any
    fontFamily?: string
    orderCategory?: string
    imageBorderRadius?: string
    barBorderRadius?: string
    webappcolor?: {
      backgroundbuttonhome?: string
      backgroundcart?: string
      backgroundfooter?: string
      backgroundheader?: string
      backgroundmenu?: string
      backgroundstatus?: string
      backgroundstatusactive?: string
      backgroundtitlebar?: string
      backgroundwebapp?: string
      fontbutton?: string
      fontbuttonhome?: string
      fontcart?: string
      fontcategory?: string
      fontheader?: string
      fontinfocart?: string
      fontmenu?: string
      fontstatus?: string
      fonttitlebar?: string
      highlightfooter?: string
      iconsfooter?: string
      iconsheader?: string
      icontitlebar?: string
      colorIcons?: string
      iconButtonBackground?: string
      iconButtonBackgroundColor?: string
      webappbutton?: string
      iconHeaderFooterColor?: string
      priceCardBackground?: string
      priceCardFontColor?: string
    }
    useCategoryList?: boolean
    restaurantList?: boolean
    restaurantDisplayMode?: boolean
    canAcessseRestaurant?: boolean
    iconButtonSize?: string
    shadowImage?: string
    skipLoudScreen?: boolean
    blackLogoNine?: boolean
  }
}

const fontFamilyList = [
  {value: 'inter', select: 'Inter'},
  {value: 'poppins', select: 'Poppins'},
  {value: 'roboto', select: 'Roboto'},
  {value: 'open-sans', select: 'Open Sans'},
]

const typeIconButtonColor = [
  {value: 'default', label: 'Padrão'},
  {value: 'transparent', label: 'Transparente'},
  {value: 'custom', label: 'Personalizada'},
]

const iconButtonSizeOptions = [
  {value: 'default', select: 'Padrão (8 x 8) px'},
  {value: 'small', select: 'Pequeno (7 x 7) px'},
  {value: 'big', select: 'Grande (9 x 9) px'},
]

const shadowImages = [
  {value: 'default', select: 'Máximo'},
  {value: 'medium', select: 'Balanceado'},
  {value: 'without', select: 'Desativado'},
]

const EditarWebappContent: FC = () => {
  const navigate = useNavigate()
  const {id} = useParams()

  /* Estados realmente usados no HTML e/ou nas funções de salvar/carregar */
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState('')
  const [locationId, setLocationId] = useState<null | number>(null) // usado em save/get/load
  const [info, setInfo] = useState('') // usado em save/get/load

  const [background, setBackground] = useState<File | null | string>() // HTML + upload
  const [banner, setBanner] = useState<File | null | string>() // upload (não no HTML, mas mantido)
  const [img, setImg] = useState<File | null | string>() // HTML + upload
  const [imgLoundPage, setImgLoundPage] = useState<File | null | string>() // HTML + upload
  const [icon, setIcon] = useState<File | null | string>() // upload (não no HTML, mas mantido)

  const [firstStateBackground, setFirstStateBackground] = useState<null | string>()
  const [firstStateBanner, setFirstStateBanner] = useState<null | string>()
  const [firstStateImg, setFirstStateImg] = useState<null | string>()
  const [firstStateIcon, setFirstStateIcon] = useState<null | string>()
  const [firstStateImgLoundPage, setFirstStateImgLoundPage] = useState<null | string>()

  const [fontFamily, setFontFamily] = useState<string>('inter') // HTML + content
  const [defaultColor, setDefaultColor] = useState<string>() // HTML -> color

  const [restaurantList, setRestaurantList] = useState<boolean>(false)
  const [restaurantDisplayMode, setRestaurantDisplayMode] = useState<boolean>(false)
  const [canAcessseRestaurant, setCanAcesseRestaurant] = useState<boolean>(false)

  const [iconButtonSize, setIconButtonSize] = useState<string>('default')

  const [shadowImage, setShadowImage] = useState<string>('default')

  //novos campos
  const [skipLoudScreen, setSkipLoudScreen] = useState<boolean>(false)
  const [blackLogoNine, setBlackLogoNine] = useState<boolean>(false)

  // webappcolor (todos exibidos no HTML)
  const [webappbutton, setWebappbutton] = useState<string>('') // botão principal
  const [iconHeaderFooterColor, setIconHeaderFooterColor] = useState<string>('') // cor do ícone do cabeçalho e rodapé
  const [imageBorderRadius, setImageBorderRadius] = useState<string>('12')
  const [barBorderRadius, setBarBorderRadius] = useState<string>('0')
  const [colorIcons, setColorIcons] = useState<string>('#3B82F6')
  const [iconButtonBackground, setIconButtonBackground] = useState<string>('default')
  const [iconButtonBackgroundColor, setIconButtonBackgroundColor] = useState<string>('')
  const [priceCardBackground, setPriceCardBackground] = useState<string>('#efeeed')
  const [priceCardFontColor, setPriceCardFontColor] = useState<string>('')

  const [backgroundbuttonhome, setBackgroundbuttonhome] = useState<string>('') // HTML
  const [backgroundfooter, setBackgroundfooter] = useState<string>('') // HTML
  const [backgroundheader, setBackgroundheader] = useState<string>('') // HTML
  const [fontbutton, setFontbutton] = useState<string>('') // HTML
  const [fontbuttonhome, setFontbuttonhome] = useState<string>('') // HTML

  // usados no save/get/load mas não aparecem no HTML; mantidos para não quebrar
  const [qtdProductsPagination, setQtdProductsPagination] = useState(10)
  const [useLogoMenu, setUseLogoMenu] = useState(false)
  const [colorLogo, setColorLogo] = useState('black')
  const [useLogoTotvs, setUseLogoTotvs] = useState(false)
  const [backgroundcart, setBackgroundcart] = useState<string>('')
  const [backgroundmenu, setBackgroundmenu] = useState<string>('')
  const [backgroundstatus, setBackgroundstatus] = useState<string>('')
  const [backgroundstatusactive, setBackgroundstatusactive] = useState<string>('')
  const [backgroundtitlebar, setBackgroundtitlebar] = useState<string>('')
  const [backgroundwebapp, setBackgroundwebapp] = useState<string>('')
  const [fontcart, setFontcart] = useState<string>('')
  const [fontcategory, setFontcategory] = useState<string>('')
  const [fontheader, setFontheader] = useState<string>('')
  const [fontinfocart, setFontinfocart] = useState<string>('')
  const [fontmenu, setFontmenu] = useState<string>('')
  const [fontstatus, setFontstatus] = useState<string>('')
  const [fonttitlebar, setFonttitlebar] = useState<string>('')
  const [highlightfooter, setHighlightfooter] = useState<string>('')
  const [iconsfooter, setIconsfooter] = useState<string>('')
  const [iconsheader, setIconsheader] = useState<string>('')
  const [icontitlebar, setIcontitlebar] = useState<string>('')
  const [pdv, setPdv] = useState<any>()
  const [useCategoryList, setUseCategoryList] = useState(false)
  const [noShadow, setNoShadow] = useState(false)
  const [orderCategory, setOrderCategory] = useState('category')

  const [canAlert, setCanAlert] = useState(false)

  // Slider do agregador — removido por não ser usado no HTML nem nas funções desta página

  const urlOrS3 = (maybePath: string | null) => {
    if (!maybePath) return null
    return maybePath.substring(0, 4) === 'http'
      ? maybePath
      : process.env.REACT_APP_AWS_S3_URL + maybePath
  }

  const getAppconfig = async () => {
    try {
      setLoading(true)
      const appRes = await GET(`/appconfig/${id}`)
      const appconfig: AppconfigResponseType = appRes.data[0]

      setName(appconfig.name)
      setLocationId(appconfig.locationId)
      setInfo(appconfig.info)
      setDefaultColor(appconfig.color)

      // imagens principais
      const bg = urlOrS3(appconfig.background)
      const bn = urlOrS3(appconfig.banner)
      const im = urlOrS3(appconfig.img)
      const imLoundPage = urlOrS3(appconfig.imgLoundPage)
      const ic = urlOrS3(appconfig.icon)

      setBackground(bg)
      setBanner(bn)
      setImg(im)
      setImgLoundPage(imLoundPage)
      setIcon(ic)

      setFirstStateBackground(bg)
      setFirstStateBanner(bn)
      setFirstStateImg(im)
      setFirstStateIcon(ic)
      setFirstStateImgLoundPage(imLoundPage)

      // fontes (pode vir do topo ou de content.fontFamily)
      if (appconfig.fontFamily) setFontFamily(appconfig.fontFamily)
      if (appconfig.content?.fontFamily) setFontFamily(appconfig.content.fontFamily)
      if (appconfig.content?.imageBorderRadius != null) {
        setImageBorderRadius(appconfig.content.imageBorderRadius)
      }
      if (appconfig.content?.barBorderRadius != null)
        setBarBorderRadius(appconfig.content.barBorderRadius)
      if (appconfig.content?.restaurantList != null)
        setRestaurantList(appconfig.content.restaurantList)
      if (appconfig.content?.restaurantDisplayMode != null)
        setRestaurantDisplayMode(appconfig.content.restaurantDisplayMode)
      if (appconfig.content?.canAcessseRestaurant != null)
        setCanAcesseRestaurant(appconfig.content.canAcessseRestaurant)
      if (appconfig.content?.iconButtonSize != null)
        setIconButtonSize(appconfig.content.iconButtonSize)
      if (appconfig.content?.shadowImage != null) {
        setShadowImage(appconfig.content.shadowImage)
      }
      if (appconfig.content?.skipLoudScreen !== undefined)
        setSkipLoudScreen(appconfig.content.skipLoudScreen)
      if (appconfig.content?.blackLogoNine !== undefined)
        setBlackLogoNine(appconfig.content.blackLogoNine)

      // webappcolor
      const wc = appconfig.content?.webappcolor || {}
      if (wc.backgroundheader) setBackgroundheader(wc.backgroundheader)
      if (wc.backgroundfooter) setBackgroundfooter(wc.backgroundfooter)
      if (wc.backgroundbuttonhome) setBackgroundbuttonhome(wc.backgroundbuttonhome)
      if (wc.fontbutton) setFontbutton(wc.fontbutton)
      if (wc.fontbuttonhome) setFontbuttonhome(wc.fontbuttonhome)
      if (wc.colorIcons) setColorIcons(wc.colorIcons)
      if (wc.iconButtonBackground) setIconButtonBackground(wc.iconButtonBackground)
      if (wc.iconButtonBackgroundColor) setIconButtonBackgroundColor(wc.iconButtonBackgroundColor)
      if (wc.webappbutton) setWebappbutton(wc.webappbutton)
      if (wc.iconHeaderFooterColor) setIconHeaderFooterColor(wc.iconHeaderFooterColor)
      if (wc.priceCardBackground) setPriceCardBackground(wc.priceCardBackground)
      if (wc.priceCardFontColor) setPriceCardFontColor(wc.priceCardFontColor)

      // demais campos que a API mantém (mesmo não aparecendo no HTML)
      if (appconfig.content?.qtdProductsPagination !== undefined)
        setQtdProductsPagination(appconfig.content.qtdProductsPagination)
      if (appconfig.content?.useLogoMenu !== undefined)
        setUseLogoMenu(appconfig.content.useLogoMenu)
      if (appconfig.content?.colorLogo) setColorLogo(appconfig.content.colorLogo)
      if (appconfig.content?.useLogoTotvs !== undefined)
        setUseLogoTotvs(appconfig.content.useLogoTotvs)
      if (appconfig.content?.pdv !== undefined) setPdv(appconfig.content.pdv)
      if (appconfig.content?.orderCategory) setOrderCategory(appconfig.content.orderCategory)
      if (appconfig.content?.useCategoryList !== undefined)
        setUseCategoryList(appconfig.content.useCategoryList)
      if (appconfig.content?.noShadow !== undefined) setNoShadow(appconfig.content.noShadow)

      if (appconfig.content?.skipLoudScreen !== undefined)
        setSkipLoudScreen(appconfig.content.skipLoudScreen)
      if (appconfig.content?.blackLogoNine !== undefined)
        setBlackLogoNine(appconfig.content.blackLogoNine)

      if (wc.backgroundcart) setBackgroundcart(wc.backgroundcart)
      if (wc.backgroundmenu) setBackgroundmenu(wc.backgroundmenu)
      if (wc.backgroundstatus) setBackgroundstatus(wc.backgroundstatus)
      if (wc.backgroundstatusactive) setBackgroundstatusactive(wc.backgroundstatusactive)
      if (wc.backgroundtitlebar) setBackgroundtitlebar(wc.backgroundtitlebar)
      if (wc.backgroundwebapp) setBackgroundwebapp(wc.backgroundwebapp)
      if (wc.fontcart) setFontcart(wc.fontcart)
      if (wc.fontcategory) setFontcategory(wc.fontcategory)
      if (wc.fontheader) setFontheader(wc.fontheader)
      if (wc.fontinfocart) setFontinfocart(wc.fontinfocart)
      if (wc.fontmenu) setFontmenu(wc.fontmenu)
      if (wc.fontstatus) setFontstatus(wc.fontstatus)
      if (wc.fonttitlebar) setFonttitlebar(wc.fonttitlebar)
      if (wc.highlightfooter) setHighlightfooter(wc.highlightfooter)
      if (wc.iconsfooter) setIconsfooter(wc.iconsfooter)
      if (wc.iconsheader) setIconsheader(wc.iconsheader)
      if (wc.icontitlebar) setIcontitlebar(wc.icontitlebar)

      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const deleteImage = async (image: string) => {
    try {
      await POST('/upload-images/delete-one', {url: image})
    } catch {
      return null
    }
  }

  const saveAppconfig = async () => {
    try {
      if (!name || !locationId) {
        setCanAlert(true)
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      }

      setLoading(true)

      const appconfigData: AppconfigResponseSendType = {
        name,
        info,
        locationId,
        color: defaultColor,
      }

      // LOGO
      if (img && img !== firstStateImg) {
        if (firstStateImg) await deleteImage(firstStateImg)
        const formData = new FormData()
        formData.append('file', img as File)
        formData.append('nameImage', `appconfig-logo-${uuid()}.jpg`)
        formData.append('originalSize', 'true')
        const imageRes = await POST('/upload-images/upload-one', formData)
        appconfigData.img = imageRes.success ? imageRes.image : ''
      }
      if (!img || img === '') appconfigData.img = img as any

      // ÍCONE
      if (icon && icon !== firstStateIcon) {
        if (firstStateIcon) await deleteImage(firstStateIcon)
        const formData = new FormData()
        formData.append('file', icon as File)
        formData.append('nameImage', `appconfig-icon-${uuid()}.jpg`)
        formData.append('originalSize', 'true')
        const imageRes = await POST('/upload-images/upload-one', formData)
        appconfigData.icon = imageRes.success ? imageRes.image : ''
      }
      if (!icon || icon === '') appconfigData.icon = icon as any

      // BANNER
      if (banner && banner !== firstStateBanner) {
        if (firstStateBanner) await deleteImage(firstStateBanner)
        const formData = new FormData()
        formData.append('file', banner as File)
        formData.append('nameImage', `appconfig-banner-${uuid()}.jpg`)
        formData.append('originalSize', 'true')
        const imageRes = await POST('/upload-images/upload-one', formData)
        appconfigData.banner = imageRes.success ? imageRes.image : ''
      }
      if (!banner || banner === '') appconfigData.banner = banner as any

      // BACKGROUND
      if (background && background !== firstStateBackground) {
        if (firstStateBackground) await deleteImage(firstStateBackground)
        const formData = new FormData()
        formData.append('file', background as File)
        formData.append('nameImage', `appconfig-background-${uuid()}.jpg`)
        formData.append('originalSize', 'true')
        const imageRes = await POST('/upload-images/upload-one', formData)
        appconfigData.background = imageRes.success ? imageRes.image : ''
      }
      if (!background || background === '') appconfigData.background = background as any

      // IMG LOUNGE PAGE
      if (imgLoundPage && imgLoundPage !== firstStateImgLoundPage) {
        if (firstStateImgLoundPage) await deleteImage(firstStateImgLoundPage)
        const formData = new FormData()
        formData.append('file', imgLoundPage as File)
        formData.append('nameImage', `appconfig-imgLoundPage-${uuid()}.jpg`)
        formData.append('originalSize', 'true')
        const imageRes = await POST('/upload-images/upload-one', formData)
        appconfigData.imgLoundPage = imageRes.success ? imageRes.image : ''
      }
      if (!imgLoundPage || imgLoundPage === '') appconfigData.imgLoundPage = imgLoundPage as any

      // Content (apenas o que a página de fato usa + o que a API exige)
      appconfigData.content = {
        qtdProductsPagination,
        useLogoMenu,
        colorLogo,
        useLogoTotvs,
        noShadow,
        orderCategory,
        pdv,
        imageBorderRadius,
        barBorderRadius,
        webappcolor: {
          backgroundbuttonhome,
          backgroundcart,
          backgroundfooter,
          backgroundheader,
          backgroundmenu,
          backgroundstatus,
          backgroundstatusactive,
          backgroundtitlebar,
          backgroundwebapp,
          fontbutton,
          fontbuttonhome,
          fontcart,
          fontcategory,
          fontheader,
          fontinfocart,
          fontmenu,
          fontstatus,
          fonttitlebar,
          highlightfooter,
          iconsfooter,
          iconsheader,
          icontitlebar,
          colorIcons,
          iconButtonBackground,
          iconButtonBackgroundColor,
          webappbutton,
          iconHeaderFooterColor,
          priceCardBackground,
          priceCardFontColor,
        },
        useCategoryList,
        fontFamily,
        restaurantList,
        restaurantDisplayMode,
        canAcessseRestaurant,
        iconButtonSize,
        shadowImage,
        skipLoudScreen,
        blackLogoNine,
      }

      const appconfigRes = await PUT(`/appconfig/${id}`, appconfigData)
      setLoading(false)

      if (appconfigRes.success === true) {
        setCanAlert(false)
        Swal.fire({
          icon: 'success',
          title: 'Configuração alterada',
          text: 'Edição realizada com sucesso!',
        }).then(() => navigate('/webapp'))
      } else {
        setCanAlert(true)
        Swal.fire({icon: 'error', title: 'Erro', text: 'Erro ao alterar configuração!'})
      }
    } catch (e) {
      setCanAlert(true)
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e && typeof e === 'string' ? e : 'Erro ao alterar configuração!',
      })
    }
  }

  const handleUnload = (e: BeforeUnloadEvent) => {
    e.preventDefault()
    e.returnValue = true
    localStorage.removeItem('webapp-personalize-saved')
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleUnload)
    return () => window.removeEventListener('beforeunload', handleUnload)
  }, []) // dependência não é necessária

  // ---- Persistência local: somente o que a página usa/recupera ----
  const loadLocal = () => {
    const raw = localStorage.getItem('webapp-personalize-saved')
    if (!raw) return
    const j = JSON.parse(raw)
    setLoading(true)

    // básicos
    if (typeof j.name === 'string') setName(j.name)
    if (typeof j.locationId !== 'undefined') setLocationId(j.locationId)
    if (typeof j.info === 'string') setInfo(j.info)

    // imagens
    if (typeof j.background === 'string') setBackground(j.background)
    if (typeof j.banner === 'string') setBanner(j.banner)
    if (typeof j.img === 'string') setImg(j.img)
    if (typeof j.icon === 'string') setIcon(j.icon)
    if (typeof j.firstStateBackground === 'string') setFirstStateBackground(j.firstStateBackground)
    if (typeof j.firstStateBanner === 'string') setFirstStateBanner(j.firstStateBanner)
    if (typeof j.firstStateImg === 'string') setFirstStateImg(j.firstStateImg)
    if (typeof j.firstStateIcon === 'string') setFirstStateIcon(j.firstStateIcon)
    if (typeof j.firstStateImgLoundPage === 'string')
      setFirstStateImgLoundPage(j.firstStateImgLoundPage)

    // aparência
    if (typeof j.fontFamily === 'string') setFontFamily(j.fontFamily)
    if (typeof j.defaultColor === 'string') setDefaultColor(j.defaultColor)
    if (typeof j.imageBorderRadius === 'string') setImageBorderRadius(j.imageBorderRadius)
    if (typeof j.barBorderRadius === 'string') setBarBorderRadius(j.barBorderRadius)
    if (typeof j.restaurantList === 'boolean') setRestaurantList(j.restaurantList)
    if (typeof j.restaurantDisplayMode === 'boolean')
      setRestaurantDisplayMode(j.restaurantDisplayMode)
    if (typeof j.canAcessseRestaurant === 'boolean') setCanAcesseRestaurant(j.canAcessseRestaurant)
    if (typeof j.iconButtonSize === 'string') setIconButtonSize(j.iconButtonSize)
    if (typeof j.shadowImage === 'string') setShadowImage(j.shadowImage)
    if (typeof j.skipLoudScreen === 'boolean') setSkipLoudScreen(j.skipLoudScreen)
    if (typeof j.blackLogoNine === 'boolean') setBlackLogoNine(j.blackLogoNine)

    // webappcolor (somente os usados na página)
    if (typeof j.webappbutton === 'string') setWebappbutton(j.webappbutton)
    if (typeof j.colorIcons === 'string') setColorIcons(j.colorIcons)
    if (typeof j.iconButtonBackground === 'string') setIconButtonBackground(j.iconButtonBackground)
    if (typeof j.iconButtonBackgroundColor === 'string')
      setIconButtonBackgroundColor(j.iconButtonBackgroundColor)
    if (typeof j.priceCardBackground === 'string') setPriceCardBackground(j.priceCardBackground)
    if (typeof j.priceCardFontColor === 'string') setPriceCardFontColor(j.priceCardFontColor)

    if (typeof j.backgroundbuttonhome === 'string') setBackgroundbuttonhome(j.backgroundbuttonhome)
    if (typeof j.backgroundfooter === 'string') setBackgroundfooter(j.backgroundfooter)
    if (typeof j.backgroundheader === 'string') setBackgroundheader(j.backgroundheader)
    if (typeof j.fontbutton === 'string') setFontbutton(j.fontbutton)
    if (typeof j.fontbuttonhome === 'string') setFontbuttonhome(j.fontbuttonhome)

    // extras mantidos (a API pode devolver/esperar)
    if (typeof j.qtdProductsPagination !== 'undefined')
      setQtdProductsPagination(j.qtdProductsPagination)
    if (typeof j.useLogoMenu !== 'undefined') setUseLogoMenu(j.useLogoMenu)
    if (typeof j.colorLogo === 'string') setColorLogo(j.colorLogo)
    if (typeof j.useLogoTotvs !== 'undefined') setUseLogoTotvs(j.useLogoTotvs)
    if (typeof j.backgroundcart === 'string') setBackgroundcart(j.backgroundcart)
    if (typeof j.backgroundmenu === 'string') setBackgroundmenu(j.backgroundmenu)
    if (typeof j.backgroundstatus === 'string') setBackgroundstatus(j.backgroundstatus)
    if (typeof j.backgroundstatusactive === 'string')
      setBackgroundstatusactive(j.backgroundstatusactive)
    if (typeof j.backgroundtitlebar === 'string') setBackgroundtitlebar(j.backgroundtitlebar)
    if (typeof j.backgroundwebapp === 'string') setBackgroundwebapp(j.backgroundwebapp)
    if (typeof j.fontcart === 'string') setFontcart(j.fontcart)
    if (typeof j.fontcategory === 'string') setFontcategory(j.fontcategory)
    if (typeof j.fontheader === 'string') setFontheader(j.fontheader)
    if (typeof j.fontinfocart === 'string') setFontinfocart(j.fontinfocart)
    if (typeof j.fontmenu === 'string') setFontmenu(j.fontmenu)
    if (typeof j.fontstatus === 'string') setFontstatus(j.fontstatus)
    if (typeof j.fonttitlebar === 'string') setFonttitlebar(j.fonttitlebar)
    if (typeof j.highlightfooter === 'string') setHighlightfooter(j.highlightfooter)
    if (typeof j.iconsfooter === 'string') setIconsfooter(j.iconsfooter)
    if (typeof j.iconsheader === 'string') setIconsheader(j.iconsheader)
    if (typeof j.icontitlebar === 'string') setIcontitlebar(j.icontitlebar)
    if (typeof j.pdv !== 'undefined') setPdv(j.pdv)
    if (typeof j.useCategoryList !== 'undefined') setUseCategoryList(j.useCategoryList)
    if (typeof j.noShadow !== 'undefined') setNoShadow(j.noShadow)
    if (typeof j.orderCategory === 'string') setOrderCategory(j.orderCategory)

    localStorage.removeItem('webapp-personalize-saved')
    setTimeout(() => setLoading(false), 200)
  }

  const saveLocal = () => {
    const payload = {
      // básicos
      name,
      locationId,
      info,

      // imagens
      background,
      banner,
      img,
      icon,
      firstStateBackground,
      firstStateBanner,
      firstStateImg,
      firstStateIcon,

      // aparência
      fontFamily,
      defaultColor,
      restaurantList,
      restaurantDisplayMode,
      canAcessseRestaurant,
      iconButtonSize,
      shadowImage,

      // webappcolor (somente os usados na página)
      webappbutton,
      imageBorderRadius,
      barBorderRadius,
      colorIcons,
      iconButtonBackground,
      iconButtonBackgroundColor,
      backgroundbuttonhome,
      backgroundfooter,
      backgroundheader,
      fontbutton,
      fontbuttonhome,
      priceCardBackground,
      priceCardFontColor,

      // extras mantidos
      qtdProductsPagination,
      useLogoMenu,
      colorLogo,
      useLogoTotvs,
      backgroundcart,
      backgroundmenu,
      backgroundstatus,
      backgroundstatusactive,
      backgroundtitlebar,
      backgroundwebapp,
      fontcart,
      fontcategory,
      fontheader,
      fontinfocart,
      fontmenu,
      fontstatus,
      fonttitlebar,
      highlightfooter,
      iconsfooter,
      iconsheader,
      icontitlebar,
      pdv,
      useCategoryList,
      noShadow,
      orderCategory,
    }
    localStorage.setItem('webapp-personalize-saved', JSON.stringify(payload))
  }

  useEffect(() => {
    const cached = localStorage.getItem('webapp-personalize-saved')
    if (cached && JSON.parse(cached)) loadLocal()
    else getAppconfig()
  }, [])

  useEffect(() => {
    return () => {
      if (canAlert && !window.location.pathname.includes(`/webapp/editar/${id}`)) {
        Swal.fire({
          title: 'Sair da página?',
          text: 'Há alterações não salvas que serão perdidas se você sair da página.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sair',
          cancelButtonText: 'Continuar editando',
        }).then((result) => {
          if (!result.isConfirmed) {
            navigate(`/webapp/editar/${id}`)
          } else {
            localStorage.removeItem('webapp-personalize-saved')
          }
        })
      } else if (!canAlert) {
        localStorage.removeItem('webapp-personalize-saved')
      }
    }
  }, [window.location.pathname, canAlert])

  useEffect(() => {
    saveLocal()
  }, [
    // campos exibidos/alterados na UI
    name,
    fontFamily,
    restaurantList,
    restaurantDisplayMode,
    canAcessseRestaurant,
    iconButtonSize,
    shadowImage,
    imageBorderRadius,
    barBorderRadius,
    background,
    img,
    defaultColor,
    backgroundheader,
    backgroundfooter,
    webappbutton,
    fontbutton,
    backgroundbuttonhome,
    fontbuttonhome,
    colorIcons,
    iconButtonBackground,
    iconButtonBackgroundColor,
    priceCardBackground,
    priceCardFontColor,

    // necessários pro envio/consistência
    locationId,
    info,
    banner,
    icon,
    firstStateBackground,
    firstStateBanner,
    firstStateImg,
    firstStateIcon,

    // extras mantidos (API)
    qtdProductsPagination,
    useLogoMenu,
    colorLogo,
    useLogoTotvs,
    backgroundcart,
    backgroundmenu,
    backgroundstatus,
    backgroundstatusactive,
    backgroundtitlebar,
    backgroundwebapp,
    fontcart,
    fontcategory,
    fontheader,
    fontinfocart,
    fontmenu,
    fontstatus,
    fonttitlebar,
    highlightfooter,
    iconsfooter,
    iconsheader,
    icontitlebar,
    pdv,
    useCategoryList,
    noShadow,
    orderCategory,
  ])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='d-flex flex-row justify-content-between flex-wrap gap-5 '>
            <div className='card' style={{flex: 1, minWidth: '30em'}}>
              <div className='card-header py-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bold fs-4 mb-1'>
                    {i18n.t(`webapp.webapp_data`)}
                  </span>
                  <BreadCrumbs />
                </h3>
              </div>
              <div className='px-10 py-5'>
                <div className='w-100 flex-wrap gap-5'>
                  <div className='d-flex flex-column justify-content-between align-items-center gap-5'>
                    <div className='w-100'>
                      <Input
                        inputAttr={{type: 'default'}}
                        placeholder={i18n.t(`webapp.name`)}
                        label={i18n.t(`webapp.name`)}
                        value={name}
                        change={(value: string) => {
                          setCanAlert(true)
                          setName(value)
                        }}
                      />
                    </div>
                    <div className='w-100'>
                      <Input
                        inputAttr={{type: 'select'}}
                        options={fontFamilyList}
                        label={i18n.t(`webapp.family_fonte`)}
                        value={fontFamily}
                        change={(value: string) => {
                          setCanAlert(true)
                          setFontFamily(value)
                        }}
                      />
                    </div>
                    <div className='w-100'>
                      <Input
                        inputAttr={{type: 'select'}}
                        options={iconButtonSizeOptions}
                        label={i18n.t(`webapp.icon_button_size`)}
                        value={iconButtonSize}
                        change={(value: string) => {
                          setCanAlert(true)
                          setIconButtonSize(value)
                        }}
                      />
                    </div>
                    <div className='w-100'>
                      <Input
                        inputAttr={{type: 'select'}}
                        options={shadowImages}
                        label={i18n.t(`webapp.shadow_image`)}
                        value={shadowImage}
                        change={(value: string) => {
                          setCanAlert(true)
                          setShadowImage(value)
                        }}
                      />
                    </div>
                    <div className='w-100'>
                      <Input
                        inputAttr={{type: 'slider'}}
                        label={i18n.t(`webapp.rounding_images`)}
                        value={imageBorderRadius}
                        change={(value: string) => {
                          setCanAlert(true)
                          setImageBorderRadius(value)
                        }}
                        minNumber={0}
                        maxNumber={30}
                        textToSlider='px'
                        textToMinNumber='(Quadrado)'
                        textToMaxNumber='(Muito Arredondado)'
                      />
                    </div>
                    <div className='w-100'>
                      <Input
                        inputAttr={{type: 'slider'}}
                        label={i18n.t(`webapp.rounding_bars`)}
                        value={barBorderRadius}
                        change={(value: string) => {
                          setCanAlert(true)
                          setBarBorderRadius(value)
                        }}
                        minNumber={0}
                        maxNumber={80}
                        textToSlider='%'
                        textToMinNumber='(Quadrado)'
                        textToMaxNumber='(Muito Arredondado)'
                      />
                    </div>

                    <div className='flex flex-col w-100 gap-2'>
                      <div className='mt-4'>
                        <Input
                          inputAttr={{type: 'checkbox'}}
                          label={i18n.t(`webapp.restaurant_list`)}
                          value={restaurantList}
                          change={(value: boolean) => {
                            setCanAlert(true)
                            setRestaurantList(value)
                          }}
                          checked={restaurantList}
                        />
                      </div>
                      <div className='mt-4'>
                        <Input
                          inputAttr={{type: 'checkbox'}}
                          label={i18n.t(`webapp.restaurant_display_mode`)}
                          value={restaurantDisplayMode}
                          change={(value: boolean) => {
                            setCanAlert(true)
                            setRestaurantDisplayMode(value)
                          }}
                          checked={restaurantDisplayMode}
                        />
                      </div>
                      <div className='mt-4'>
                        <Input
                          inputAttr={{type: 'checkbox'}}
                          label={i18n.t(`webapp.can_acesse_restaurant`)}
                          value={canAcessseRestaurant}
                          change={(value: boolean) => {
                            setCanAlert(true)
                            setCanAcesseRestaurant(value)
                          }}
                          checked={canAcessseRestaurant}
                          toolTip={true}
                          toolTipIcon={'info-circle'}
                          toolTiptext={i18n.t(`webapp.info_acesse_restaurant`)}
                        />
                      </div>
                      <div className='mt-4'>
                        <Input
                          inputAttr={{type: 'checkbox'}}
                          label={i18n.t(`webapp.black_logo_nine`)}
                          value={blackLogoNine}
                          change={(value: boolean) => {
                            setCanAlert(true)
                            setBlackLogoNine(value)
                          }}
                          checked={blackLogoNine}
                        />
                      </div>
                      <div className='mt-4'>
                        <Input
                          inputAttr={{type: 'checkbox'}}
                          label={i18n.t(`webapp.skip_loud_screen`)}
                          value={skipLoudScreen}
                          change={(value: boolean) => {
                            setCanAlert(true)
                            setSkipLoudScreen(value)
                          }}
                          checked={skipLoudScreen}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='d-flex justify-content-between align-items-start mt-6 gap-5'>
                    <div className='justify-content-start d-flex w-100'>
                      <Input
                        inputAttr={{type: 'image'}}
                        label='Background WebApp'
                        value={background}
                        change={(value: BaseSyntheticEvent) => {
                          setCanAlert(true)
                          setBackground(value ? value.target.files[0] : null)
                        }}
                      />
                    </div>
                    <div className='justify-content-start d-flex w-100'>
                      <Input
                        inputAttr={{type: 'image'}}
                        label='Logo Webapp'
                        value={img}
                        change={(value: BaseSyntheticEvent) => {
                          setCanAlert(true)
                          setImg(value ? value.target.files[0] : null)
                        }}
                      />
                    </div>

                    <div className='justify-content-start d-flex w-100'>
                      <Input
                        inputAttr={{type: 'image'}}
                        label='LoundPage Webapp'
                        value={imgLoundPage}
                        change={(value: BaseSyntheticEvent) => {
                          setCanAlert(true)
                          setImgLoundPage(value ? value.target.files[0] : null)
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='card' style={{flex: 1, minWidth: '30em'}}>
              <div className='card-header py-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bold fs-4 mb-1'>
                    {i18n.t(`webapp.color_setting`)}
                  </span>
                </h3>
              </div>

              <div className='px-10 py-5'>
                <div className='row g-4'>
                  {/* <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.background_webapp`)}
                      value={defaultColor}
                      change={(value: string) => {
                        setCanAlert(true)
                        setDefaultColor(value)
                      }}
                    />
                  </div> */}
                  <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.background_header`)}
                      value={backgroundheader}
                      change={(value: string) => {
                        setCanAlert(true)
                        setBackgroundheader(value)
                      }}
                    />
                  </div>
                  <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.background_footer`)}
                      value={backgroundfooter}
                      change={(value: string) => {
                        setCanAlert(true)
                        setBackgroundfooter(value)
                      }}
                    />
                  </div>
                  <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.webapp_button`)}
                      value={webappbutton}
                      change={(value: string) => {
                        setCanAlert(true)
                        setWebappbutton(value)
                      }}
                    />
                  </div>
                  {/* <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.text_button`)}
                      value={fontbutton}
                      change={(value: string) => {
                        setCanAlert(true)
                        setFontbutton(value)
                      }}
                    />
                  </div> */}
                  <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.home_button`)}
                      value={backgroundbuttonhome}
                      change={(value: string) => {
                        setCanAlert(true)
                        setBackgroundbuttonhome(value)
                      }}
                    />
                  </div>
                  <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.text_home_button`)}
                      value={fontbuttonhome}
                      change={(value: string) => {
                        setCanAlert(true)
                        setFontbuttonhome(value)
                      }}
                    />
                  </div>
                  <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.color_icons`)}
                      value={colorIcons}
                      change={(value: string) => {
                        setCanAlert(true)
                        setColorIcons(value)
                      }}
                    />
                  </div>
                  <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.color_icons_header_footer`)}
                      value={iconHeaderFooterColor}
                      change={(value: string) => {
                        setCanAlert(true)
                        setIconHeaderFooterColor(value)
                      }}
                    />
                  </div>

                  <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.price_card_background`)}
                      value={priceCardBackground}
                      change={(value: string) => {
                        setCanAlert(true)
                        setPriceCardBackground(value)
                      }}
                    />
                  </div>

                  <div className='col-6'>
                    <Input
                      inputAttr={{type: 'color'}}
                      label={i18n.t(`webapp.price_card_font_color`)}
                      value={priceCardFontColor}
                      change={(value: string) => {
                        setCanAlert(true)
                        setPriceCardFontColor(value)
                      }}
                    />
                  </div>

                  <div className='col-12'>
                    <Input
                      inputAttr={{type: 'radio-button'}}
                      label={i18n.t(`webapp.background_icon_button`)}
                      options={typeIconButtonColor}
                      value={iconButtonBackground}
                      change={(value: string) => {
                        setIconButtonBackground(value)
                        value !== 'custom' && setIconButtonBackgroundColor('')
                      }}
                    />
                    {iconButtonBackground === 'custom' && (
                      <div>
                        <Input
                          inputAttr={{type: 'color'}}
                          label={i18n.t(`webapp.background_icon_custom`)}
                          value={iconButtonBackgroundColor}
                          change={setIconButtonBackgroundColor}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex justify-content-between align-items-center mt-10'>
            <Button
              text={i18n.t(`buttons.back`)}
              color='info'
              size='small'
              horizontalPadding={6}
              btnAttr={{type: 'button'}}
              click={() => navigate('/webapp')}
              btnClass='fw-bolder'
            />
            <Button
              text={i18n.t(`buttons.save`)}
              color='primary'
              size='small'
              horizontalPadding={6}
              btnAttr={{type: 'button'}}
              click={() => {
                setCanAlert(false)
                saveAppconfig()
              }}
              btnClass='fw-bolder'
            />
          </div>
        </div>
      )}
    </>
  )
}

const EditarWebappHotel: FC = () => {
  return (
    <>
      <EditarWebappContent />
    </>
  )
}

export {EditarWebappHotel}
